import Model from "../Model";

export default class extends Model {
  async loadTable(page, limit, search = '') {
    let response = await super.list(page, limit, search).then(result => {return result});
    let result = {
      tbody: [],
      pages: response.pages,
    };
    if(response.items !== undefined && response.items.length > 0)
    {
      response.items.forEach(group => {
        let telem = {
          tbody: {}
        };
        telem.id = group.id;
        telem.tbody.name = group.name;
        result.tbody.push(telem);
      });
    }
    return result;
  }
}
